import { render, staticRenderFns } from "./RegistResult.vue?vue&type=template&id=6bee14cf&scoped=true&v-slot%3Acontent=true&"
import script from "./RegistResult.vue?vue&type=script&lang=ts&"
export * from "./RegistResult.vue?vue&type=script&lang=ts&"
import style0 from "./RegistResult.vue?vue&type=style&index=0&id=6bee14cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee14cf",
  null
  
)

export default component.exports